module.exports = __webpack_public_path__ + "img/uploadImage-delete-icon.c80e5e74.svg";